<template>
  <div>
    <!-- Start Header Area -->
    <Header>
      <img
        slot="logo"
        :src="logoParticles"
        class="logo-light"
        style="max-width: 13rem"
        alt="Smile Magazine Logo"
      />
      <img
        slot="logo-dark"
        :src="logoScroll"
        class="logo-dark"
        alt="Smile Magazine Logo"
      />
    </Header>
    <!-- End Header Area -->

    <!-- Start Slider Area  -->
    <div class="rn-slider-area poss_relative" id="home">
      <vue-particles
        color="#dedede"
        :particleOpacity="0.7"
        :particlesNumber="40"
        shapeType="circle"
        :particleSize="4"
        linesColor="#dedede"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="180"
        :moveSpeed="6"
        :hoverEffect="true"
        hoverMode="repulse"
        :clickEffect="false"
        clickMode="push"
      >
      </vue-particles>
      <div
        class="slide slide-style-2 bg_image bg_image--27 d-flex align-center"
        :style="{ backgroundImage: 'url(' + headerImage + ')' }"
      >
        <Banner>
          <h1 slot="heading-title" class="heading-title" :style="{color: `${headerTitleColor}`}">
            {{ headerTitle }}
          </h1>
          <p slot="description" class="description" :style="{color: `${headerSubtitleColor}`}">
            {{ headerSubtitle }}
          </p>
        </Banner>
      </div>
    </div>
    <!-- End Slider Area -->

    <!-- Start Portfolio Area -->
    <div class="rn-portfolio-area rn-section-gap bg_color--1">
      <div class="portfolio-sacousel-inner">
        <News />
      </div>
    </div>
    <!-- End Portfolio Area -->

    <!-- Start Counterup Area -->
    <div
        class="rn-counterup-area rn-section-gap parallax bg_image bg-fixed"
        :style="{ backgroundImage: 'url(' + counterImg + ')' }"
    >
      <v-container>
        <Services />
      </v-container>
    </div>
    <!-- End Counterup Area -->

    <!-- Start team Area  -->
    <div class="rn-team-area team-area rn-section-gap bg_color--1">
      <v-container>
        <Team />
      </v-container>
    </div>
    <!-- End team Area  -->

    <div class="rn-gallery-area bg_color--1 position-relative">
      <Works />
    </div>

    <!-- Start Brand Area -->
    <div class="rn-brand-area brand-area bg_color--1 rn-section-gap">
      <v-container>
        <Brands />
      </v-container>
    </div>
    <!-- End Brand Area -->

    <!-- Start Footer Area  -->
    <Footer />
    <!-- End Footer Area  -->
  </div>
</template>

<script>
  import Header from "../layout/header/HeaderOnePage.vue";
  import Banner from "../home/sections/Banner.vue";
  import About from "../../components/about/About";
  import News from "../home/sections/news.vue"
  import ServiceThree from "../../components/service/ServiceThree";
  import PortfolioTwo from "../../components/portfolio/PortfolioTwo";
  import CounterOne from "../../components/counter/CounterOne";
  import Testimonial from "../../components/testimonial/Testimonial";
  import BlogTwo from "../../components/blog/BlogTwo";
  import Contact from "../../components/contact/Contact";
  import Brand from "../../components/brand/Brand";
  import Footer from "../../pages/layout/footer/Footer.vue";
  import Portfolio from "@/components/portfolio/Portfolio.vue";
  import {container} from "@/main";
  import {HomeService} from "@/pages/home/home.service";
  import Works from "../home/sections/works.vue"
  import Services from "@/pages/portfolio/sections/services.vue";
  import BrandTwo from "@/components/brand/BrandTwo.vue";
  import Brands from "@/pages/home/sections/Brands.vue";
  import TeamTwo from "@/components/team/TeamTwo.vue";
  import Team from "@/pages/home/sections/Team.vue";

  export default {
    components: {
      TeamTwo,
      BrandTwo,
      Services,
      Portfolio,
      Header,
      News,
      Works,
      Banner,
      About,
      ServiceThree,
      PortfolioTwo,
      CounterOne,
      Team,
      Testimonial,
      BlogTwo,
      Brand,
      Contact,
      Footer,
      Brands,
    },
    methods: {
      async renderHeader() {
        const _this = this;
        const header = await _this.homeService.getHeader();
        const parser = new DOMParser();
        const doc = parser.parseFromString(header.content.rendered, 'text/html');
        _this.headerTitle = doc.querySelector("body > h2").textContent;
        _this.headerTitleColor = doc.querySelector("body > h2").style.color;
        _this.headerSubtitle = doc.querySelector("body > p").textContent;
        _this.headerSubtitleColor = doc.querySelector("body > p").style.color;
        const img = doc.querySelector("body > figure > img");
        const logos = doc.querySelectorAll("body > div img")
        _this.logoParticles = logos[0].src;
        _this.logoScroll = logos[1].src;
        _this.headerImage = img.src;
      },
      async renderCounterUp() {
        const services = await this.homeService.getServices();
        const parser = new DOMParser();
        const doc = parser.parseFromString(services.content.rendered, 'text/html');
        this.counterImg = doc.querySelector('.wp-block-image > img').getAttribute('data-orig-file');
      },
    },
    async created() {
      this.homeService = container.get(HomeService);
      await this.renderHeader();
      await this.renderCounterUp();
    },
    watch: {
      '$route'(to, from) {
        if (to.name === 'Home') {
          this.$nextTick(async () => {
            if (document.readyState === 'complete') {
              // El DOM está listo y la página está completamente cargada
              await this.renderHeader();
              await this.renderCounterUp();
            } else {
              // Esperar a que la página se cargue completamente
              window.addEventListener('load', this.renderHeader);
              await this.renderCounterUp();
            }
          });
        }
      },
    },
    data() {
      return {
        headerImage: null,
        counterImg: null,
        homeService: null,
        tab: null,
        index: null,
        headerTitle: null,
        headerTitleColor: null,
        headerSubtitle: null,
        headerSubtitleColor: null,
        logoParticles: null,
        logoScroll: null,
        tabItems: [],
        tabContent: [],
        portfolioContent: [
          {
            src: require("../../assets/images/portfolio/portfolio-2.jpg"),
            meta: "Development",
            title: "Getting tickets to the big show",
          },
          {
            src: require("../../assets/images/portfolio/portfolio-5.jpg"),
            meta: "Development",
            title: "Getting tickets to the big show bayazid",
          },
          {
            src: require("../../assets/images/portfolio/portfolio-6.jpg"),
            meta: "Development",
            title: "Getting tickets to the big show iqra",
          },
          {
            src: require("../../assets/images/portfolio/portfolio-7.jpg"),
            meta: "Development",
            title: "Getting tickets to the big show",
          },
          {
            src: require("../../assets/images/portfolio/portfolio-8.jpg"),
            meta: "Development",
            title: "Getting tickets to the big show",
          },
        ],
        // for all works
        settings: {
          dots: true,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          spaceBetween: 15,

          responsive: [
            {
              breakpoint: 890,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
              },
            },
            {
              breakpoint: 770,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
              },
            },
            {
              breakpoint: 490,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: 1,
              },
            },
          ],
        },
      };
    },
  };
</script>
